import {createTheme, assignProps} from '@sail/engine';
import {tokens as $} from '@sail/tokens';
import {IconConfig} from '../../components/Icon';
import {RadioConfig} from '../../components/Radio';

const visualRefreshRadioOverride = RadioConfig.customize({
  css: {
    gapY: 'xxsmall',
  },
  subviews: {
    label: {
      css: {
        color: $['color.hue.slate.1000'],
        paddingLeft: 'medium',
      },
      uses: [assignProps({size: 'medium', emphasis: 'normal'})],
    },
    description: {
      css: {
        font: 'label.medium',
        paddingLeft: 'medium',
      },
    },
    error: {
      css: {
        color: $['color.hue.red.600'],
        font: 'label.medium',
        paddingLeft: 'medium',
      },
      uses: [IconConfig.customize({css: {display: 'none'}})],
    },
    input: {
      css: {
        height: 'medium',
        width: 'medium',
        boxShadow: '0 0 0 0 transparent',

        ':disabled': {
          backgroundColor: 'form',
        },

        '[aria-invalid="true"]': {
          keyline: $['color.hue.red.600'],
        },

        '::before': {
          height: 'medium',
          width: 'medium',
        },

        '[aria-invalid="true"]::before': {
          keyline: $['color.hue.red.600'],
        },

        ':checked::before': {
          backgroundColor: $['color.hue.blurple.600'],
          keyline: $['color.hue.blurple.600'],
        },

        ':checked:disabled::before': {
          backgroundColor: $['color.hue.blurple.400'],
          keyline: $['color.hue.blurple.400'],
        },

        '[aria-invalid="true"]:checked::before': {
          keyline: $['color.hue.red.600'],
        },
      },
    },
  },
});

export const visualRefreshRadioTheme = createTheme(
  {
    name: 'Visual Refresh Radio',
    description: 'Visual refresh styling for Radio.',
    category: 'Visual Refresh',
    internal: true,
  },
  [visualRefreshRadioOverride],
);
